async function retry(fn, retries, delayFn) {
  let attempt = 0;
  while (attempt <= retries) {
    try {
      return await fn();
    } catch (error) {
      if (attempt === retries) throw error;
      attempt++;
      if (delayFn) {
        // eslint-disable-next-line
        await new Promise((resolve) => setTimeout(resolve, delayFn(attempt)));
      }
    }
  }
  throw new Error("Unexpected error in retry mechanism");
}

export async function processWithRetry(functions, options) {
  return Promise.all(
    functions.map(async (fn) => await retry(fn, options.retries, options.delay))
  );
}
